import storification from "../../../store/modules/storification";

const maxFilesPerNetwork = {
    facebook: 20,
    instagram: 20,
    linkedin: 20,
    google: 1,
    threads: 10,
    twitter: 4,
    bluesky: 4,
    tiktok: 35,
    youtube: 1,
    pinterest: 1,
    telegram: 0
};

const maxCharactersByNetworkForText = {
    facebook: () => 63206,
    instagram:() => 2200,
    linkedin: () => 3000,
    threads: () => 500,
    twitter: ({page}) => (!page || !page.story_config || page.story_config.verified_type == 'none' ? 280 : 25000),
    google: () => 1500,
    tiktok: ({files}) => (files && files.length > 0 && files[0].type2 === 'image' ? 4090 : 2200),
    telegram: () => Infinity,
    pinterest: () => Infinity,
    youtube: () => Infinity,
    bluesky:() =>  300,
}

const formDataDefault = {
    planifiedDate: {
        date: false,
        hours: false,
        timestamp: false
    },
    textContent: "",
    mentions: {
       
        // "1740753951170":{
        //     mention: {
        //         facebook:{
        //             "id":"422294267901716",
        //             "name":"Clem",
        //             "link":"https://www.facebook.com/422294267901716"
        //         },
        //         instagram:{
        //             "id":"clemence_kohlanta23",
        //             "name":"Koh Lanta le feu sacre 🌋",
        //             "image":"base64",
        //             "pk":8575579104
        //         }
        //     },
        //     "textDefault":"TEST"
        // }
        
    },
    idMentionSelected : null,
    comments: [''],
    urlsTextContent:[],
    urlsTextContentHistory: [],
    files : [],
    formDataNetwork: {
        facebook: {
            visibility: 'all',
            snippet: {
                link: '',
                title: "",
                description: "",
                imageUrl:""
            },
            typeMedia : 'image',
            isReel : true,//assert typeMedia == 'video'
            place : null,
        },
        instagram: {
            personsIdentified : [],
            collaborators : [],
            products : [],
            music : null,
            place : null,
            ratio : "auto", // '4:5' | '1:1' | '16:9' | 'auto'
            storification: {
                active: false,
                shareInFacebook: false, //condition => active == true
                planifiedDate: {
                    date: false,
                    hours: false,
                    timestamp: false
                },
            }
            
        },
        linkedin: {
            typeMedia : 'image',
            survey : {
                active : false,
                duration: 'threeDay',
                question : 'Aimes-tu les chats ?',
                options : ['Oui','Non']
            },
            snippet: {
                customActived: false,
                link: '',
                title: '',
                image: undefined
            },
        },
        threads: {
            snippet: {
                link: '',
                imageUrl: ''
            },
        },
        twitter: {
            typeContent : 'image',
            snippet: {
                link: '',
            },
            tweetSplitting: {
                active: false,
            }
        },
        bluesky: {},
        tiktok: {
            visibility : 'all',
            commentDisable: false,
            useVideoForDuo: true,
            useVideoForOtherVideo: true,
            autoAddMusic: false,
            photoCoverIndex: 0,
            brandContentToggle: false,
            brandOrganicToggle: false,
            isAigc: false,
            music: null,
        },
        google: {
            snippet: {
                link: '',
            },
        },
        telegram: {},
        pinterest: {
            snippet: {
                link: '',
            },
            boardSelectedByPage : {
                //de798d54-17e5-4d26-b709-d1affc1f4808:"815151669994570630"
            }
        },
        youtube: {
            visibility : 'all',
            category : "22",
            notifySubscribers: true,
            contentForChildren: false,
            tags : [], //["Bonjour","hello"]
            playlistSelectedByPage : {
                //2417e61a-bf73-4f0a-b188-bf767be44e22:"PLawhS2vT8ZbTDd2r1ryprtK2bpCTl4W_H"
            }
        }
    },
    storification : {
        '0' : {
            hide: false,
            background : {
                // file : {
                //     id: 1234567890,
                //     type:'image/jpeg',
                //     name:'imageDefault',
                //     size: 0,
                //     url : 'https://i.pinimg.com/236x/84/bd/bc/84bdbc1507a0697fe9288477342b2005.jpg', //temporaire
                // },
                file: null,
            
                color : '#f8f1e0',
                size : 'containY', // 'cover' | 'containX' | 'containY'
                position: {"x":50,"y":50},
                transform: {"rotate":0,"scale":1}
                
            },
            stickers : {},
            highlight: {
                id:null,
                text:null,
            },
            shareInFacebook: false
        }
    }
}

const acceptedFileTypesPerNetwork = {
    // valeurs utilisables pour comparer à file.type (ex: file.type === 'image/jpeg')
    default: [
        'image/jpeg', 'image/png', 'image/gif', 'image/webp', 'application/pdf',
        'video/mp4', 'video/webm', 'video/ogg', 'video/x-msvideo', // avi
        'video/x-ms-wmv', 'video/x-flv', 'video/x-matroska', // mkv
        'video/quicktime' // mov
    ],

    facebook: [
        'image/jpeg', 'image/png', 'image/webp',
        'video/mp4', 'video/webm', 'video/ogg', 'video/x-msvideo',
        'video/x-ms-wmv', 'video/x-flv', 'video/x-matroska', 'video/quicktime'
    ],

    instagram: [
        'image/jpeg', 'image/png', 'image/webp',
        'video/mp4', 'video/webm', 'video/ogg', 'video/x-msvideo',
        'video/x-ms-wmv', 'video/x-flv', 'video/x-matroska', 'video/quicktime'
    ],

    linkedin: [
        'image/jpeg', 'image/png', 'image/webp',
        'video/mp4', 'video/webm', 'video/ogg', 'video/x-msvideo',
        'video/x-ms-wmv', 'video/x-flv', 'video/x-matroska', 'video/quicktime',
        'application/pdf'
    ],

    threads: [
        'image/jpeg', 'image/png', 'image/webp',
        'video/mp4', 'video/webm', 'video/ogg', 'video/x-msvideo',
        'video/x-ms-wmv', 'video/x-flv', 'video/x-matroska', 'video/quicktime'
    ],

    twitter: [
        'image/jpeg', 'image/png', 'image/gif', 'image/webp',
        'video/mp4', 'video/webm', 'video/ogg', 'video/x-msvideo',
        'video/x-ms-wmv', 'video/x-flv', 'video/x-matroska', 'video/quicktime'
    ],

    bluesky: [
        'image/jpeg', 'image/png', 'image/webp',
        'video/mp4', 'video/webm', 'video/ogg', 'video/x-msvideo',
        'video/x-ms-wmv', 'video/x-flv', 'video/x-matroska', 'video/quicktime'
    ],

    tiktok: [
        'image/jpeg', 'image/png', 'image/webp',
        'video/mp4', 'video/webm', 'video/quicktime', 'video/x-matroska'
    ],

    google: [
        'image/jpeg', 'image/png', 'image/webp',
    ],

    telegram: [], // pas de support géré

    pinterest: [
        'image/jpeg', 'image/png', 'image/webp',
        'video/mp4', 'video/webm', 'video/quicktime', 'video/x-matroska'
    ],

    youtube: [
        'video/mp4', 'video/webm', 'video/x-matroska', 'video/quicktime', 'video/x-msvideo', 'video/x-flv'
    ]
}
// helper pour input accept (si besoin) : acceptedFileTypes[type]?.join(',') || acceptedFileTypes.default.join(',')
/* ...existing code... */

const draftTemplate = {
    "multipleImages":[],
    "multipleMedias":[],
    "activeMentionsAutoReplace":true,
    "activeHashtagsAutoAdd":true,
    "validMentions":[],
    "mentionsAdded":[],
    "hashtagsAdded":[],
    "activePrefixSuffix":false,
    "layers":[],
    "carrouselRatio":1,
    "instagramTexts":[],
    "instagramTextsUpdater":[],
    "storyLinkText":"",
    "snippetTitle":"",
    "snippet":null,
    "carouselOrderDragElement":null,
    "poll":{"question":"","options":["",""],"duration":604800},
    "templateManual":null,
    "instagramLinkPosition":{"x":160,"y":440,"color":0},
    "highlightInstagram":null,
    "instagramBackgroundColor":null,
    "sharedStoryUrl":"",
    "storySharedVisual":null,
    "screenshot":null,
    "videoReel":true,
    "videoReelFB":false,
    "videos":"{\"twitter\":null,\"facebook\":null,\"facebook_reel\":null,\"linkedin\":null,\"instagram\":null,\"instagram_reel\":null,\"story\":null}",
    "location":null,
    "userTags":null,
    "storyVideo":false,
    "pollStory":null,
    "sliderStory":null,
    "musicStory":null,
    "gifsStory":[],
    "mentionsWidget":[],
    "filename":null,
    "videoname":null,
    "validHashtags":[],
    "storyMultiple":[],
    "shareAfterPost":false,
    "storificationData":{"link":null},
    "storyShareToFacebook":false,
    "compressedImages":[],
    "tiktokOptions":"{\"comment_disabled\":false,\"duet_disabled\":true,\"stitch_disabled\":true,\"privacy_level\":\"SELF_ONLY\",\"auto_add_music\":false,\"photo_cover_index\":0}",
    "youtubeOptions":"{\"notifySubscribers\":true,\"madeForKids\":false,\"privacy_level\":\"public\",\"category\":\"22\",\"tag\":\"\",\"tags\":[],\"playlist\":null}",
    "log":[],
    "typePost": "standard",
}

const listNetworkSort = ['facebook','instagram','linkedin','google','threads','twitter','bluesky','tiktok','youtube','pinterest','telegram']
const editableNetworks = ['facebook','instagram','linkedin']

export { 
    maxFilesPerNetwork,
    maxCharactersByNetworkForText,
    formDataDefault,
    draftTemplate,
    listNetworkSort,
    editableNetworks,
    acceptedFileTypesPerNetwork
};
  



